import React from "react";
import "../../assets/scss/app.scss";
import {BrowserRouter, Router} from "react-router-dom";
import history from "../../history";
import {I18nextProvider} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import i18next from "i18next";
import {config as i18nextConfig} from "../../translations";
import Routes from "./Routes/";
import Auth0ProviderWithHistory from "../../components/Auth0ProviderWithHistory";
import NavbarComponent from "../../components/NavbarComponent";

i18next.use(LanguageDetector).init(i18nextConfig);

const App = () => {
    return (
        <BrowserRouter>
            <Auth0ProviderWithHistory>
                <I18nextProvider i18n={i18next}>
                    <Router history={history}>
                        <NavbarComponent/>
                        <Routes/>
                    </Router>
                </I18nextProvider>
            </Auth0ProviderWithHistory>
        </BrowserRouter>
    );
}

export default App;
